import {
  SpiritTaskItem,
  TaskBuying,
  TaskEvent,
  TaskInstagramFeed,
  TaskInstagramReel,
  TaskInstagramStories,
  TaskSampling,
  TaskTikTokFeed,
  TaskWebApp,
  TaskXPost,
  TaskYoutubeFeed,
} from '@/api/spirit';
import instagram from '@/assets/instagram.png';
import tiktok from '@/assets/tiktok.png';
import x from '@/assets/TwitterLogo.png';
import youtube from '@/assets/youtube.png';
import { TaskKeyType, taskType } from '@/components/ProjectManagements/Modals/ModalHearing';

import { Buying } from './tasks/buying';
import { Event } from './tasks/event';
import { Post } from './tasks/post';
import { Sampling } from './tasks/sampling';
import { Web } from './tasks/web';

export const TaskManeger = (props: { tasks: SpiritTaskItem[] }) => {
  const { tasks } = props;
  const components = tasks.map((task) => {
    switch (taskType[task.taskType as TaskKeyType]) {
      case taskType[1]:
        return <Sampling task={task.detail as TaskSampling} />;
      case taskType[2]:
      case taskType[3]:
        return <Buying task={task.detail as TaskBuying} />;
      case taskType[4]:
        return <Event task={task.detail as TaskEvent} />;
      case taskType[5]:
        return <Web task={task.detail as TaskWebApp} />;
      case taskType[10]:
        return <Post task={task.detail as TaskInstagramFeed} title={'フィード投稿'} imagePath={instagram} />;
      case taskType[11]:
        return <Post task={task.detail as TaskInstagramStories} title={'ストーリーズ投稿'} imagePath={instagram} />;
      case taskType[12]:
        return <Post task={task.detail as TaskInstagramReel} title={'リール投稿'} imagePath={instagram} />;
      case taskType[20]:
        return <Post task={task.detail as TaskXPost} title={'ポスト投稿'} imagePath={x} />;
      case taskType[21]:
        return <Post task={task.detail as TaskXPost} title={'引用ポスト投稿'} imagePath={x} />;
      case taskType[30]:
        return <Post task={task.detail as TaskTikTokFeed} title={'動画投稿(TikTok)'} imagePath={tiktok} />;
      case taskType[40]:
        return <Post task={task.detail as TaskYoutubeFeed} title={'動画投稿(Youtube)'} imagePath={youtube} />;
      default:
        return <div></div>;
    }
  });

  return <>{components}</>;
};
